import { render, staticRenderFns } from "./report-problem.vue?vue&type=template&id=d15ff4c2"
import script from "./report-problem.vue?vue&type=script&lang=js"
export * from "./report-problem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports